import { render, staticRenderFns } from "./DownloadView.vue?vue&type=template&id=3b3c2b04&scoped=true&"
import script from "./DownloadView.vue?vue&type=script&lang=js&"
export * from "./DownloadView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3c2b04",
  null
  
)

export default component.exports